import DateColumn from '../column-helpers/date/date-component';
import AuditStatusColumn from '../column-helpers/audit_status/audit-status-component';
import {AUDIT_STATUSES, PERMISSION_LEVEL} from '../column-helpers/auditPolicyConstants';
import PermissionLevelColumn from '../column-helpers/permission_level/permission-level-component';

const getMappedDeviceConstant = (auditConstant) => {
  const mappedObject = {};
  Object.values(auditConstant).forEach((el) => {
    mappedObject[el.name] = el.title;
  });

  return mappedObject;
};

export const auditPoliciesColumnConfig = {
  name: {
    label: 'Name',
    type: 'text',
    width: 220,
    shown: true,
    priority: 1,
  },
  description: {
    label: 'Description',
    type: 'text',
    width: 140,
    shown: false,
    priority: 2,
  },
  permissionLevel: {
    label: 'Permission Level',
    priority: 3,
    options: PERMISSION_LEVEL,
    columnRendererComponent: PermissionLevelColumn,
    shown: true,
  },
  lastAuditTime: {
    label: 'Audit On',
    type: 'text',
    columnRendererComponent: DateColumn,
    width: 140,
    shown: true,
    priority: 4,
  },
  lastAuditBy: {
    label: 'Audit By',
    type: 'text',
    width: 140,
    shown: false,
    priority: 5,
  },
  lastAuditStatus: {
    label: 'Audit Status',
    type: 'text',
    columnRendererComponent: AuditStatusColumn,
    width: 140,
    shown: true,
    priority: 6,
    options: getMappedDeviceConstant(AUDIT_STATUSES),
  },
  lastAuditDeviceCount: {
    label: 'Total Devices',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 7,
  },
  lastAuditDeviceSuccessCount: {
    label: 'Audited Devices',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 8,
  },
  // lastAuditDevicesInViolationCount: {
  //     label: 'Device Violations',
  //     dataType: 'integer',
  //     width: 150,
  //     shown: false,
  //     priority: 8
  // },
  lastAuditDeviceErrorCount: {
    label: 'Device Errors',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 9,
  },
  lastAuditViolationCount: {
    label: 'Failed Devices',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 10,
  },
  lastAuditCriticalViolationCount: {
    label: 'Critical Violations',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 11,
  },
  lastAuditMajorViolationCount: {
    label: 'Major Violations',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 12,
  },
  lastAuditMinorViolationCount: {
    label: 'Minor Violations',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 13,
  },
  lastAuditInfoViolationCount: {
    label: 'Informational Violations',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 14,
  },
  lastAuditDevicesNotInViolationCount: {
    label: 'Passed Devices',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 15,
  },
  updatedOn: {
    label: 'Updated On',
    type: 'datetime',
    columnRendererComponent: DateColumn,
    width: 140,
    shown: false,
    priority: 16,
  },
  updatedBy: {
    label: 'Updated By',
    width: 140,
    type: 'text',
    shown: false,
    priority: 17,
  },
};
